/*
 * @author BSG <dev@bsgroup.eu>
 * @copyright Better Software Group S.A.
 * @version: 1.0
 */
import React, { useCallback } from "react";

import { usePlayerComponents } from "../../../../../shared/context/PlayerComponentsContext";
import { usePlayerTranslation } from "../../../../../shared/context/PlayerTranslationContext";
import PauseIcon from "../../../../../shared/icons/player/Pause.svg";
import PlayIcon from "../../../../../shared/icons/player/Play.svg";
import {
  usePlayerAdvertisementTracker,
  usePlayerController,
  usePlayerSettings,
} from "../../../../BasePlayer";

export const PlayPauseButton = () => {
  const { player } = usePlayerController();
  const {
    tracker: { playing: isPlaying },
  } = usePlayerAdvertisementTracker();

  const {
    ui: { tooltipOffset },
  } = usePlayerSettings();

  const { t } = usePlayerTranslation();
  const { Button } = usePlayerComponents();
  const label = t(isPlaying ? "PLAYER_TOOLTIP_PAUSE" : "PLAYER_TOOLTIP_PLAY");

  const togglePlay = useCallback(() => {
    isPlaying ? player.pauseAd() : player.resumeAd();
  }, [player, isPlaying]);

  return (
    <Button
      variant="primary"
      onClick={togglePlay}
      tooltip={label}
      tooltipAlign="left"
      tooltipOffset={tooltipOffset}
      aria-label={label}
      iconOnly
    >
      {isPlaying ? (
        <PauseIcon aria-hidden="true" focusable="false" />
      ) : (
        <PlayIcon aria-hidden="true" focusable="false" />
      )}
    </Button>
  );
};
